import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

function SmartCityServicesContent({
  handleAddModal,
  handleRemove,
  handleEdit,
  serviceId,
  showService,
  serviceInfo,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(serviceId)) return;
    showService(serviceId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(serviceId)) return;
    showService(serviceId);
  }, [serviceId]);

  return (
    <div className="container-fluid card-section-content">
      {isLoading && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(serviceInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-8">
                  <h3 className="">E-Service Information</h3>
                </div>
                <div className="col-4 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(serviceInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(serviceInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-6 p-3">
                            <label className="full-label mb-0 thumb-label">
                              Main Icon:
                            </label>
                            <img
                              className="thumbnail-src"
                              src={
                                _.get(serviceInfo, 'attributes.photo')
                                  ? _.get(serviceInfo, 'attributes.photo')
                                  : ImagePlaceholder
                              }
                              alt=""
                            />
                          </div>
                          <div className="form-input-group col-6 p-3">
                            <label className="full-label mb-0 thumb-label">
                              Inside Icon:
                            </label>
                            <img
                              className="thumbnail-src"
                              src={
                                _.get(serviceInfo, 'attributes.icon_url')
                                  ? _.get(serviceInfo, 'attributes.icon_url')
                                  : ImagePlaceholder
                              }
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">Name:</label>
                            <span className="full-input">
                              {_.get(serviceInfo, 'attributes.name') || '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">
                              Is Active:
                            </label>
                            <span className="full-input">
                              {_.get(serviceInfo, 'attributes.is_active')
                                ? 'YES'
                                : 'NO'}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">Link:</label>
                            <span className="full-input">
                              {_.get(serviceInfo, 'attributes.link_url')}
                            </span>
                          </div>
                          <div className="form-input-group col-6 ">
                            <label className="full-label mb-0">Sequence:</label>
                            <span className="full-input">
                              {_.get(serviceInfo, 'attributes.sequence')}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">
                              Description:
                            </label>
                            <p className="content-long">
                              {_.get(serviceInfo, 'attributes.description') ||
                                '--'}
                            </p>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">
                              Tagalog Description:
                            </label>
                            <p className="content-long">
                              {_.get(serviceInfo, 'attributes.description_filipino') ||
                                '--'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

SmartCityServicesContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showService: PropTypes.instanceOf(Function).isRequired,
  serviceInfo: PropTypes.instanceOf(Object).isRequired,
  serviceId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  isLoading: api.loading.indexOf(c.SHOW_SERVICE) > -1,
  serviceInfo: _.get(api, `${c.SHOW_SERVICE}.item`) || {},
  serviceId: _.get(match, 'params.serviceId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SmartCityServicesContent);
